import React from "react";
import AuthorizationContainer from "./AuthorizationContainer";
import Footer from "./components/containers/Footer";
import Header from "./components/containers/Header";
import AppProvider from "./components/providers/AuthProvider";

const App: React.FC = () => {
  return (
    <div id="completePage" className="completePage-style">
      <div id="Header">
        <Header />
      </div>
      <div id="App">
        <AppProvider>
          <AuthorizationContainer />
        </AppProvider>
      </div>
      <div id="Footer">
        <Footer />
      </div>
    </div>
  );
};

export default App;
